import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UtilsService } from '../../services/utils.service';
import { LoaderEnabled } from '../../services/loader.service';
import { DeleteGroupBody, Group, NewGroupBody, UpdateGroupBody } from './groups.types';

@Injectable({
  providedIn: 'root',
})

export class GroupsApiService {
  constructor(
    private httpClient: HttpClient,
    private utilsService: UtilsService,
  ) {}

  @LoaderEnabled()
  fetchGroups(retailPlaceId: number, groupName: string): Observable<Group[]> {
    const params = this.utilsService.getHttpParams({
      retailPlaceId,
      groupName: groupName ?? '',
    });
    return this.httpClient.get<Group[]>('api/administration/groups', {
      params,
    });
  }

  createGroup(group: NewGroupBody): Observable<void> {
    return this.httpClient.post<void>('/api/administration/add-group', group);
  }

  deleteGroup(group: DeleteGroupBody): Observable<void> {
    return this.httpClient.post<void>('/api/administration/delete-group', group);
  }

  fetchGroup(id: number): Observable<Group> {
    return this.httpClient.get<Group>(`/api/administration/groups/${id}`);
  }

  updateGroup(group: UpdateGroupBody): Observable<void> {
    return this.httpClient.post<void>('/api/administration/edit-group', group);
  }
}
